import LogoSvg from "../../assets/images/Logo.svg";
import "./Logo.scss";

export default function Logo(props) {
  return <img className="logo" alt="" src={LogoSvg} />;
}
